import React from 'react'
import {connect} from 'react-redux'
import NavBarItem from "../components/NavBarItem"
import {setOutput, setInput} from "../actions"
import {tooltips} from "../constants"


function onMIDIStateChanged(connEvent, dispatch){
    console.log("midi state changed", connEvent)

    if(connEvent.port.name.toLowerCase().includes("datalooper")){
        if(connEvent.port.type === "output"){
            if(connEvent.port.state === "connected") {
                // Explicitly open the output port
                connEvent.port.open().then(() => {
                    console.log("Output port opened on state change");
                    dispatch(setOutput(connEvent.port))
                }).catch(err => {
                    console.error("Failed to open output port on state change:", err);
                    dispatch(setOutput(connEvent.port)) // Still set it
                });
            } else{
                dispatch(setOutput(false))
            }
        } else{
            if(connEvent.port.state === "connected") {
                // Explicitly open the input port
                connEvent.port.open().then(() => {
                    console.log("Input port opened on state change");
                    dispatch(setInput(connEvent.port))
                }).catch(err => {
                    console.error("Failed to open input port on state change:", err);
                    dispatch(setInput(connEvent.port)) // Still set it
                });
            } else{
                dispatch(setInput(false))
            }
        }
    }

}

function onMIDISuccess(midiAccess, dispatch) {
    let outputs = midiAccess.outputs.values();
    let inputs = midiAccess.inputs.values();
    midiAccess.onstatechange = function(e){ onMIDIStateChanged(e, dispatch)}

    let dlOutput = checkForDL(outputs);
    if(dlOutput){
        // Explicitly open the output port
        dlOutput.open().then(() => {
            console.log("Output port opened successfully");
            dispatch(setOutput(dlOutput))
            // Start config mode when connecting
            dlOutput.send([0xF0, 0x1E, 6, 0xF7])
            console.log("Config mode started on connection")
            
            // Wait for config mode to be ready before enabling download
            setTimeout(() => {
                console.log("Config mode should be ready now")
            }, 1000);
            window.onunload = (event) => {
                console.log("unloading")
                dlOutput.send([0xF0, 0x1E, 9, 0xF7])
            };
        }).catch(err => {
            console.error("Failed to open output port:", err);
            dispatch(setOutput(dlOutput)) // Still set it even if open fails
        });
    }

    let dlInput = checkForDL(inputs);
    if(dlInput){
        // Explicitly open the input port
        dlInput.open().then(() => {
            console.log("Input port opened successfully");
            dispatch(setInput(dlInput))
        }).catch(err => {
            console.error("Failed to open input port:", err);
            dispatch(setInput(dlInput)) // Still set it even if open fails
        });
    }

}
function checkForDL(ports){
    console.log("checking for DL")
    let port = ports.next();
    while (!port.done) {
        console.log("MIDI PORT: ", port.value)
        if(port.value.name.toLowerCase().includes("datalooper")){
            return port.value
        } else {
            port = ports.next();
        }
    }
}

function onMIDIFailure() {
    console.log('Could not access your MIDI devices.');
}

const Connect = ({name, dispatch, icon, connection}) => {
    console.log("connection",connection)
    console.log("has input:", !!connection.get('input'))
    console.log("has output:", !!connection.get('output'))
    console.log("input port:", connection.get('input'))
    console.log("output port:", connection.get('output'))
    console.log("should be green:", !!(connection.get('output') && connection.get('input')))
    if(connection.get('output') && connection.get('input')){
        return (
            <NavBarItem tooltip={tooltips.Connect} onClick= {()=>disconnectDL(dispatch, connection)} color={"#4CAF50"} icon={icon} name= {name} />
        )
    } else{

        return (
            <NavBarItem tooltip={tooltips.Connect} onClick= {()=>connectDL(dispatch)} icon={icon} name= {name} />
        )
    }

}
function connectDL(dispatch){
    navigator.requestMIDIAccess({sysex: true})
        .then(function(e){ onMIDISuccess(e, dispatch)} , onMIDIFailure);
}
function disconnectDL(dispatch, connection){
    var output = connection.get('output'), input = connection.get('input')
    output.send([0xF0, 0x1E, 9, 0xF7])
    dispatch(setOutput(false))
    dispatch(setInput(false))
}

function mapStateToProps(state){
    return{
        connection : state.connection
    }
}

export default connect(
    mapStateToProps)(Connect)